import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { useMemo } from 'react';
import RollingDateConfig from 'customer-data-filters-ui/filterQueryFormat/rollingDates/RollingDateConfig';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DisplayValueRollingDate = props => {
  const {
    operator,
    value
  } = props;
  const i18nToken = useMemo(() => RollingDateConfig.toRollingDateOptionValue(value), [value]);
  return /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `customerDataFiltersUI.customerDataFilters.RollingDates.options.text.${i18nToken}`
    }), operator && operator.rollingOffset ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "customerDataFiltersUI.customerDataFilters.DisplayValueRollingDateWithOffset.label",
      options: {
        number: operator.rollingOffset
      }
    }) : null]
  });
};
export default DisplayValueRollingDate;